import {countryCode} from "./Utils";

import ica from 'images/stores/ica.png';
import willys from 'images/stores/willys.jpg';
import citygross from 'images/stores/citygross.png';
import hemkop from 'images/stores/hemkop.jpg';
import coop from 'images/stores/coop.png';
import matse from 'images/stores/mat_se.png';
import mathem from 'images/stores/mathem.jpg';
import lidl from 'images/stores/lidl.svg';
import oob from 'images/stores/oob.svg';
import rusta from 'images/stores/rusta.png';
import discount365 from 'images/stores/365discount.webp';
import bilka from 'images/stores/bilka.png';
import burgsen from 'images/stores/brugsen.png';
import fotex from 'images/stores/fotex.jpg';
import kvickly from 'images/stores/kvickly.png';
import mink from 'images/stores/minkobmand.png';
import nemlig from 'images/stores/nemlig.jpg';
import netto from 'images/stores/netto.svg';
import rema from 'images/stores/rema1000.png';
import spar from 'images/stores/spar.png';
import superB from 'images/stores/superbrugsen.png';
import dollarstore from 'images/stores/dollarstore.jpg';
import normal from 'images/stores/normal.jpg';
import eko from 'images/stores/eko.png';
import costco from 'images/stores/costco.jpg';
import apotea from 'images/stores/apotea.png';
import apoteket from 'images/stores/apoteket.png';
import apo_hjartat from 'images/stores/apoteket-hjartat.png';
import kronans_apotek from 'images/stores/kronans-apotek.png';
import wolt from 'images/stores/wolt-market.png';
// SE:
/*
  Skippa 7, 10, 16

      "ICA", // 0
      "Willys", // 1
      "Hemköp", // 2
      "Coop", // 3
      "Mat.se", // 4
      "MatHem", // 5
      "City Gross", // 6
      "Netto", // 7
      "Lidl", // 8
      "Ö&B", // 9
      "Gekås", // 10
      "Rusta", // 11
      "Dollarstore", // 12
      "Normal", // 13
      "Willys Hemma", // 14
      "Eko Stormarknad", // 15
      "Costco", // 16
      "Apotea", // 17
      "Apoteket", // 18
      "Apoteket Hjärtat", // 19
      "Kronans Apotek", // 20
 */

// DK
/*
        "365discount", // 0
        "Bilka", // 1
        "Brugsen", // 2
        "Føtex", // 3
        "Kvickly", // 4
        "Min Købmand", // 5
        "Nemlig", // 6
        "Netto", // 7
        "Rema 1000", // 8
        "Spar", // 9
        "SuperBrugsen", // 10
 */

// public enum ChainName { ICA, WILLYS, HEMKOP, COOP, MATSE, MATHEM, CITYGROSS }
export function getStoreImageUrl(chain) {
    if (countryCode() === 'dk') {
        switch (chain) {
            case 0:
                return discount365
            case 1:
                return bilka;
            case 2:
                return burgsen;
            case 3:
                return fotex;
            case 4:
                return kvickly;
            case 5:
                return mink;
            case 6:
                return nemlig;
            case 7:
                return netto;
            case 8:
                return rema;
            case 9:
                return spar;
            case 10:
                return superB;
            case 12:
                return wolt;
            default:
                return '';
        }
    } else {
        switch (chain) {
            case 0:
                return ica;
            case 1:
                return willys;
            case 2:
                return hemkop;
            case 3:
                return coop;
            case 4:
                return matse;
            case 5:
                return mathem;
            case 6:
                return citygross;
            case 8:
                return lidl;
            case 9:
                return oob;
            case 11:
                return rusta;
            case 12:
                return dollarstore;
            case 13:
                return normal;
            case 14:
                return willys;
            case 15:
                return eko;
            case 16:
                return costco;
            case 17:
                return apotea;
            case 18:
                return apoteket;
            case 19:
                return apo_hjartat;
            case 20:
                return kronans_apotek;
            default:
                return '';
        }
    }
}
